<%= form_with(model: person_option, class: "contents") do |form| %>
  <% if person_option.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(person_option.errors.count, "error") %> prohibited this person_option from being saved:</h2>

      <ul class="list-disc ml-6">
        <% person_option.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :person_id %>
    <%= form.text_field :person_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": person_option.errors[:person_id].none?, "border-red-400 focus:outline-red-600": person_option.errors[:person_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :option_id %>
    <%= form.text_field :option_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": person_option.errors[:option_id].none?, "border-red-400 focus:outline-red-600": person_option.errors[:option_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :table_id %>
    <%= form.text_field :table_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": person_option.errors[:table_id].none?, "border-red-400 focus:outline-red-600": person_option.errors[:table_id].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
